<svg width="135" height="60" viewBox="0 0 100 60" version="1.1"
     xml:space="preserve" xmlns="http://www.w3.org/2000/svg" *ngIf="loader">
    <defs>
      <linearGradient
        [attr.x1]="loader.linearGradientPosition.x1"
        [attr.x2]="loader.linearGradientPosition.x2"
        [attr.y1]="loader.linearGradientPosition.y1"
        [attr.y2]="loader.linearGradientPosition.y2"
        id="linear">
        <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
              [attr.stop-color]="stop.color"/>
      </linearGradient>
      <radialGradient [attr.fx]="loader.radialGradientPosition.x"
                      [attr.fy]="loader.radialGradientPosition.y"
                      id="radial">
        <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
              [attr.stop-color]="stop.color"/>
      </radialGradient>
    </defs>
  <rect [attr.fill]="loader.color" x="0" y="0" width="10" height="60" rx="6">
      <animate attributeType="CSS"
               attributeName="height"
               values="60;20;60;"
               begin='0s'
               dur="1s"
               repeatCount="indefinite"/>
    <animate attributeType="CSS"
             attributeName="y"
             begin='0s'
             values="0;20;0;"
             dur="1s"
             repeatCount="indefinite"/>
  </rect>
  <rect [attr.fill]="loader.color" x="20" y="0" width="10" height="60" rx="6">
      <animate attributeType="CSS"
               attributeName="height"
               values="60;20;60"
               begin='0.2s'
               dur="1s"
               repeatCount="indefinite"/>
    <animate attributeType="CSS"
             attributeName="y"
             values="0;20;0"
             begin='0.2s'
             dur="1s"
             repeatCount="indefinite"/>
    </rect>
  <rect [attr.fill]="loader.color" x="40" y="0" width="10" height="60" rx="6">
      <animate attributeType="CSS"
               attributeName="height"
               values="60;20;60"
               begin='0.4s'
               dur="1s"
               repeatCount="indefinite"/>
    <animate attributeType="CSS"
             attributeName="y"
             values="0;20;0"
             begin='0.4s'
             dur="1s"
             repeatCount="indefinite"/>
    </rect>
  <rect [attr.fill]="loader.color" x="60" y="0" width="10" height="60" rx="6">
      <animate attributeType="CSS"
               attributeName="height"
               values="60;20;60"
               begin='0.6s'
               dur="1s"
               repeatCount="indefinite"/>
    <animate attributeType="CSS"
             attributeName="y"
             values="0;20;0"
             begin='0.6s'
             dur="1s"
             repeatCount="indefinite"/>
    </rect>
  <rect [attr.fill]="loader.color" x="80" y="0" width="10" height="60" rx="6">
      <animate attributeType="CSS"
               attributeName="height"
               values="60;20;60"
               begin='0.8s'
               dur="1s"
               repeatCount="indefinite"/>
    <animate attributeType="CSS"
             attributeName="y"
             values="0;20;0"
             begin='0.8s'
             dur="1s"
             repeatCount="indefinite"/>
    </rect>
</svg>
